// ** Navigation imports
import farm from './farm'

// ** Merge & Export
export default [...farm]
